import React, { useState, useRef, useEffect } from 'react';
import './CategoryDropdown.css';

const CategoryDropdown = ({ categories, value, onChange, onAddNew, label = 'Category' }) => {
  const [showAddNew, setShowAddNew] = useState(false);
  const [newCategory, setNewCategory] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Ensure value is always an array
  const selectedCategories = Array.isArray(value) ? value : (value ? [value] : []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleToggleCategory = (categoryName) => {
    const newSelection = selectedCategories.includes(categoryName)
      ? selectedCategories.filter(c => c !== categoryName)
      : [...selectedCategories, categoryName];
    onChange(newSelection);
  };

  const handleAddNewCategory = async () => {
    if (newCategory.trim()) {
      await onAddNew(newCategory.trim());
      setNewCategory('');
      setShowAddNew(false);
    }
  };

  return (
    <div className="category-dropdown-group" ref={dropdownRef}>
      <label className="form-label">{label}</label>
      {!showAddNew ? (
        <div className="category-multi-select">
          <div className="category-selected-display" onClick={() => setIsOpen(!isOpen)}>
            {selectedCategories.length === 0 ? (
              <span className="category-placeholder">Select categories</span>
            ) : (
              <div className="category-selected-tags">
                {selectedCategories.map((cat) => (
                  <span key={cat} className="category-tag">
                    {cat}
                    <button
                      type="button"
                      className="category-tag-remove"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleToggleCategory(cat);
                      }}
                      aria-label={`Remove ${cat} category`}
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            )}
            <span className="category-dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
          </div>
          {isOpen && (
            <div className="category-options">
              {categories.map((category) => (
                <label key={category} className="category-option">
                  <input
                    type="checkbox"
                    checked={selectedCategories.includes(category)}
                    onChange={() => handleToggleCategory(category)}
                  />
                  <span>{category}</span>
                </label>
              ))}
              <button
                type="button"
                className="category-add-new-button"
                onClick={() => {
                  setShowAddNew(true);
                  setIsOpen(false);
                }}
              >
                + Add new category
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="add-category-input">
          <input
            type="text"
            value={newCategory}
            onChange={(e) => setNewCategory(e.target.value)}
            placeholder="Enter new category name"
            className="form-input"
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleAddNewCategory();
              }
            }}
          />
          <button 
            type="button"
            className="add-category-button" 
            onClick={handleAddNewCategory}
          >
            Add
          </button>
          <button
            type="button"
            className="cancel-button"
            onClick={() => {
              setShowAddNew(false);
              setNewCategory('');
            }}
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default CategoryDropdown;

